@if (isOpen) {
<div class="modal-overlay" role="dialog" aria-modal="true" (click)="onClose()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content">
      
      <div class="modal-header">
        <h2 class="modal-title">{{ isViewMode ? 'Visualizar Lead' : 'Registrar Novo Lead' }}</h2>
        <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="leadForm" (ngSubmit)="onSubmit()" id="lead-form" class="form-grid">
          
          <div class="form-field col-span-2">
            <label for="nome" class="form-label">Nome completo <span class="required">*</span></label>
            <input type="text" id="nome" formControlName="nome" class="form-input"
                   [class.input-error]="isFieldInvalid('nome')">
            @if (isFieldInvalid('nome')) {
              <span class="error-text">Campo obrigatório</span>
            }
          </div>

          <div class="form-field">
            <label for="telefone" class="form-label">Telefone <span class="required">*</span></label>
            <input type="text" id="telefone" formControlName="telefone" class="form-input" 
                   mask="(00) 00000-0000" [class.input-error]="isFieldInvalid('telefone')">
          </div>

          <div class="form-field">
            <label for="canal" class="form-label">Canal <span class="required">*</span></label>
            <select id="canal" formControlName="canal" class="form-select" [class.input-error]="isFieldInvalid('canal')">
              <option value="" disabled selected>Selecione...</option>
              @for (p of parametros; track p.id) {
                <option [value]="p.descricao">{{ p.descricao }}</option>
              }
            </select>
          </div>

          <div class="form-field col-span-2">
            <label for="email" class="form-label">Email</label>
            <input type="email" id="email" formControlName="email" class="form-input">
          </div>

          <div class="form-field col-span-2">
            <label for="descricaoPedido" class="form-label">Descrição do Pedido</label>
            <textarea id="descricaoPedido" formControlName="descricaoPedido" class="form-input" rows="2"></textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onClose()">{{ isViewMode ? 'Fechar' : 'Cancelar' }}</button>
        @if (!isViewMode) {
          <button type="submit" form="lead-form" class="btn btn-primary" [disabled]="leadForm.invalid">
            Salvar Lead
          </button>
        }
      </div>
    </div>
  </div>
</div>
}